export function isEmptyObject(obj) {
  return Object.keys(obj).length;
}
